import { createContent, getDisplayAssetCode } from '@altify/utils';

export const content = createContent({
  en: {
    title: (productCode?: string, productName?: string) =>
      productCode
        ? `Buy ${productName} (${getDisplayAssetCode(productCode)})`
        : '',
    recurring: 'Recurring',
  },
  de: {
    title: (productCode?: string, productName?: string) =>
      productCode
        ? `Kaufe ${productName} (${getDisplayAssetCode(productCode)})`
        : '',
    recurring: 'Wiederkehrend',
  },
});
